export default "__VITE_ASSET__CrlfVcPm__"